import { useCallback, useEffect, useState } from 'react';
import {
    getDashboardLatestBookings,
    getDashboardLatestRequests,
    getDashboardOverview,
    getDashboardSalesChartData,
    getDashboardWorldSalesData,
} from '../services/dashboard.service';
import { buildDashboardStats } from '../utils/dashboardHelpers';

const emptyChartData = {
    SalesData: [],
    OrderQtyData: [],
    IncomeData: [],
};

const useDashboardData = ({ supplierId }) => {
    const [loading, setLoading] = useState(true);
    const [stats, setStats] = useState(buildDashboardStats());
    const [latestBookings, setLatestBookings] = useState([]);
    const [latestRequests, setLatestRequests] = useState([]);
    const [salesChartData, setSalesChartData] = useState(emptyChartData);
    const [worldSalesData, setWorldSalesData] = useState(emptyChartData);

    const fetchDashboardData = useCallback(async () => {
        if (supplierId === undefined || supplierId === null || supplierId === '') {
            return;
        }

        setLoading(true);

        try {
            const [
                overviewRes,
                bookingsRes,
                requestsRes,
                salesChartRes,
                worldSalesRes,
            ] = await Promise.all([
                getDashboardOverview({ supplierId }),
                getDashboardLatestBookings({ supplierId }),
                getDashboardLatestRequests({ supplierId }),
                getDashboardSalesChartData({ supplierId }),
                getDashboardWorldSalesData({ supplierId }),
            ]);

            setStats(buildDashboardStats(overviewRes));
            setLatestBookings(Array.isArray(bookingsRes) ? bookingsRes : []);
            setLatestRequests(Array.isArray(requestsRes) ? requestsRes : []);
            setSalesChartData(salesChartRes || emptyChartData);
            setWorldSalesData(worldSalesRes || emptyChartData);
        } catch (error) {
            console.error('Failed to fetch dashboard data:', error);
            setStats(buildDashboardStats());
            setLatestBookings([]);
            setLatestRequests([]);
            setSalesChartData(emptyChartData);
            setWorldSalesData(emptyChartData);
        } finally {
            setLoading(false);
        }
    }, [supplierId]);

    useEffect(() => {
        fetchDashboardData();
    }, [fetchDashboardData]);

    return {
        loading,
        stats,
        latestBookings,
        latestRequests,
        salesChartData,
        worldSalesData,
        refreshDashboard: fetchDashboardData,
    };
};

export default useDashboardData;